import debounce from 'lodash/debounce';
import differenceBy from 'lodash/differenceBy';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';

// Constants
import { isMobile } from 'constants';

const soundAlarm = () => {
  console.log(`----------debounced alarm called--------\n`);
  document.getElementById('triage-audio').play()
    .then(() => {
      console.log(`----------alarm promise resolved--------\n`);
    })
    .catch(error => {
      console.log(`----------alarm promise rejected with error--------\n`, error);
      console.log(`----------alarm promise rejected with code--------\n`, error.code);
      console.log(`----------alarm promise rejected with message--------\n`, error.message);
      console.log(`----------alarm promise rejected with name--------\n`, error.name);
    });
};
const debounceAlarm = debounce(soundAlarm, 1000, { leading: true, trailing: false });

export default function newTriageAlert(oldItems = [], currentItems = []) {
  // Never alarm on mobile
  if (isMobile) return;

  // Don't play the sound on page load
  if (!oldItems.length) return;

  const newItems = differenceBy(currentItems, oldItems, 'id');
  const needsAlarm = some(newItems, item => {
    const active = item.status === 'Active';
    const claimed = !isEmpty(item.claimed);
    const ok = item.monitoringAlertStatus === 'Ok';

    return active && !claimed && !ok;
  });

  if (needsAlarm) {
    console.log(`----------alarm called pre-debounce--------\n`);
    debounceAlarm();
  }
}




// WEBPACK FOOTER //
// ./app/utils/new-triage-alert.js